import type { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import * as postponedActionsActions from './postponedActionsActions';
import { getPostponableActionAttemptsLeft, setPostponableActionAttemptsLeft } from './postponedActionsTypes';

function* dispatchPostponedActions({
  payload: postponedActions,
}: ReturnType<typeof postponedActionsActions.dispatchPostponedActions>): SagaIterator {
  for (const postponedAction of postponedActions) {
    const { action } = postponedAction;
    if (!action) {
      throw new TypeError('dispatchPostponedActions: action required');
    }

    const attemptsLeft = getPostponableActionAttemptsLeft(action);
    if (attemptsLeft !== undefined) {
      setPostponableActionAttemptsLeft(action, attemptsLeft - 1);
    }
    const updatedAttemptsLeft = getPostponableActionAttemptsLeft(action);
    if (!action.meta || updatedAttemptsLeft === undefined || updatedAttemptsLeft) {
      yield put(action);
    } else if (postponedAction.onFailure) {
      yield call(postponedAction.onFailure);
    }
  }
}

function* dispatchPostponedActionsActionWatcher(): SagaIterator {
  yield takeEvery(postponedActionsActions.dispatchPostponedActions, dispatchPostponedActions);
}

function* dismissPostponedActions({
  payload: postponedActions,
}: ReturnType<typeof postponedActionsActions.dismissPostponedActions>): SagaIterator {
  for (const postponedAction of postponedActions) {
    if (postponedAction.onFailure) {
      yield call(postponedAction.onFailure);
    }
  }
}

function* dismissPostponedActionsActionWatcher(): SagaIterator {
  yield takeEvery(postponedActionsActions.dismissPostponedActions, dismissPostponedActions);
}

export default [dispatchPostponedActionsActionWatcher, dismissPostponedActionsActionWatcher];
